module.exports = __webpack_public_path__ + "static/media/Constituency.a506df03.svg";